import React from 'react';
import ReactDOM from 'react-dom';
import { nanoid } from 'nanoid';
import { Plugin } from 'prosemirror-state';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import { removeMenuContainer } from '../../utils';
import { blockMenuKey, getBlockMenuDefaultProps } from './utils/utils';
import { BlockMenuComponent } from './BlockMenu';

const BLOCK_MENU_CONTAINER_ID = 'block-menu-container';

export default class BlockMenu extends BaseExtension {
  get type(): string {
    return extensionType.toolbar;
  }

  get name(): string {
    return 'block_menu';
  }

  plugins({ portalApi, isLocalizedContent }: EditorOptions) {
    return [
      new Plugin({
        key: blockMenuKey,
        state: {
          init() {
            return getBlockMenuDefaultProps();
          },
          apply(tr, old) {
            const props = tr.getMeta(blockMenuKey);
            return props || old;
          },
        },
        view: (editorView) => {
          // This will be called only once. It will add a container div.
          // Block Menu will be rendered in this container div.
          let blockMenuButtonContainer = document.createElement('div');
          blockMenuButtonContainer.id = BLOCK_MENU_CONTAINER_ID;
          editorView?.dom?.parentNode?.appendChild(blockMenuButtonContainer);

          const portalKey = nanoid();
          // Need to return the following functions in the view function
          return {
            update: (view) => {
              const state = view.state;
              let props = blockMenuKey.getState(state);
              props.view = view;
              const dom = editorView?.dom?.parentNode?.querySelector(`#${BLOCK_MENU_CONTAINER_ID}`);
              if (dom) {
                portalApi.createPortal(
                  ReactDOM.createPortal(
                    <BlockMenuComponent isLocalizedContent={isLocalizedContent} {...props} />,
                    dom,
                    portalKey,
                  ),
                );
              }
            },
            destroy: () => {
              portalApi.destroyPortal(portalKey);
              removeMenuContainer(BLOCK_MENU_CONTAINER_ID, editorView);
            },
          };
        },
      }),
    ];
  }
}
